/**
 * 语言配置文件
 * 支持中英文切换
 */

export const LANGUAGES = {
  ZH: 'zh',
  EN: 'en'
};

export const languageTexts = {
  zh: {
    // SettingsDrawer 文案
    settings: {
      profile: '个人中心',
      openMode: '打开方式',
      theme: '个性主题',
      extension: '扩展程序',
      about: '关于我们',
      // 扩展程序相关
      browserExtension: '浏览器扩展程序',
      setAsNewTab: '设置为浏览器新标签页，离线快速访问',
      currentVersion: '当前版本',
      extensionEnvironment: '扩展程序环境',
      webEnvironment: '网页环境',
      getLatestVersion: '获取最新版本',
      extensionFeatures: '扩展程序功能',
      newTabNavigation: '新标签页导航',
      offlineQuickAccess: '离线快速访问',
      personalizedCustomization: '个性化定制',
      dataSync: '数据同步',
      privacyProtection: '隐私保护',
      supportedBrowsers: '支持的浏览器',
      // 关于我们相关
      contactEmail: '联系邮箱',
      privacyPolicy: '隐私政策',
      privacyPolicyDesc: '了解我们如何保护您的隐私和数据安全',
      appName: 'AI灯塔导航',
      appSlogan: '让工作更智能，让生活更美好',
      login: '登录',
      logout: '退出登录',
      guest: '游客模式',
      loggedIn: '已登录',
      notLoggedIn: '未登录',
      welcomeBack: '欢迎回来！',
      dataSynced: '您的数据已同步，享受完整功能体验',
      loginToSync: '登录后可以同步您的数据和设置',
      dataSyncing: '已登录，数据同步中',
      localDataOnly: '未登录，仅使用本地数据',
      sync: '同步',
      syncing: '同步中',
      reset: '重置',
      export: '导出本站数据',
      import: '导入本站数据',
      importChromeBookmarks: '导入Chrome书签',
      autoFocusSearch: '进入导航自动聚焦搜索',
      showSearch: '搜索功能展示',
      showQuickSearch: '站内网站快捷搜索展示',
      displayMode: '显示模式',
      compactDisplay: '极简显示',
      detailedDisplay: '详情显示',
      iconSize: '图标大小',
      iconRadius: '图标圆角',
      iconSpacing: '图标间距',
      iconTextColor: '图标文字颜色',
      dockVisible: '是否在底部显示应用程序快捷方式',
      sideNavAutoHide: '页面分类自动隐藏',
      extensionTitle: '浏览器扩展程序',
      extensionDesc: '设置为浏览器新标签页，离线快速访问',
      extensionTooltip: '推荐您使用扩展程序，享受更好的体验',
      extensionVersion: '当前版本',
      extensionEnv: '扩展程序环境',
      webEnv: '网页环境',
      getLatestVersion: '获取最新版本',
      extensionFeatures: '扩展程序功能',
      newTabNav: '新标签页导航',
      offlineAccess: '离线快速访问',
      personalization: '个性化定制',
      dataSync: '数据同步',
      privacyProtection: '隐私保护',
      supportedBrowsers: '支持的浏览器',
      contactEmail: '联系邮箱',
      privacyPolicy: '隐私政策',
      privacyPolicyDesc: '了解我们如何保护您的隐私和数据安全',
      disclaimer: '免责声明',
      disclaimerDesc: '查看免责声明和用户责任',
      followWeChat: '关注微信公众号',
      wechatDesc: '实时获取新功能推送、AI技巧及工具分享',
      scanToFollow: '扫码关注，不错过任何精彩内容 ✨',
      updateLog: '更新日志',
      userFeedback: '用户反馈',
      faq: '常见问题',
      officialWebsite: '应用官网',
      icpRecord: '备案信息',
      icpNumber: '京ICP备2024100595号-4',
      version: 'AI灯塔导航',
      tagline: '让工作更智能，让生活更美好'
    },
    // SideNav 文案
    sideNav: {
      login: '登录',
      editCategory: '编辑分类',
      delete: '删除',
      clickToLogin: '点击登录',
      user: '用户',
      confirmLogout: '确认登出',
      confirmLogoutText: '确定要退出登录吗？',
      loginSuccess: '登录成功！您可以在设置页面中同步数据'
    },
    // Dock 文案
    dock: {
      recentUsed: '最近使用',
      mostUsed: '最常用'
    },
    // TopBar 文案
    topBar: {
      searchPlaceholders: {
        baidu: '百度一下，你就知道',
        google: 'Google 一下，你就知道',
        sogou: '搜狗一下，你就知道'
      },
      searchEngines: {
        baidu: '百度',
        google: 'Google',
        sogou: '搜狗'
      },
      weekDays: ['日', '一', '二', '三', '四', '五', '六']
    },
    // 认证相关文案
    auth: {
      login: '用户登录',
      register: '注册账号',
      resetPassword: '重置密码',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      verificationCode: '邮箱验证码',
      getVerificationCode: '获取验证码',
      sending: '发送中...',
      resendAfter: '秒后重试',
      loginSuccess: '登录成功',
      registerSuccess: '注册成功，请登录',
      resetPasswordSuccess: '密码重置成功',
      loggingIn: '登录中...',
      syncingData: '正在同步数据...',
      dataSyncComplete: '数据同步完成',
      partialSyncFailed: '部分数据同步失败，请稍后重试',
      loginFailed: '登录失败，请稍后重试',
      enterEmail: '请输入您的邮箱',
      enterValidEmail: '请输入有效的邮箱地址',
      enterPassword: '请输入您的密码',
      enterVerificationCode: '请输入验证码',
      codeShouldBeSixDigits: '验证码应为6位数字',
      passwordLength: '密码长度为6-32个字符',
      confirmPasswordRequired: '请确认密码',
      passwordsDoNotMatch: '两次输入的密码不匹配',
      userAgreement: '《用户协议》',
      privacyPolicyText: '《隐私政策》',
      alreadyRead: '我已阅读并同意',
      and: '和',
      haveAccount: '已有账号？',
      noAccount: '还没有账号？',
      loginNow: '立即登录',
      registerNow: '立即注册',
      forgotPassword: '忘记密码?',
      backToLogin: '返回登录',
      sendToEmail: '验证码已发送到邮箱',
      verifyAccount: '验证账号',
      verifyEmail: '验证邮箱',
      setNewPassword: '重置密码',
      setNewPasswordDesc: '设置新密码',
      nextStep: '下一步',
      prevStep: '上一步',
      verificationCodeSent: '验证码已发送到邮箱 {email}',
      verifyCodeFailed: '验证码验证失败，请检查验证码是否正确',
      resetPasswordFailed: '密码重置失败，请稍后重试',
      codeSending: '发送验证码',
      setPassword: '设置密码(6-32位)',
      codeSentTo: '验证码已发送到邮箱',
      manuallyAdd: '手动添加',
      hotAdd: '热门添加',
      cardComponent: '卡片组件',
      user: '用户',
      resetPassword: '重置密码',
      followWeChatTitle: '关注微信公众号',
      followWeChatDesc: '扫码关注，获取最新功能推送和AI技巧分享',
      followWeChatTips: '关注后即可继续登录/注册',
      skipFollow: '跳过',
      alreadyFollowed: '我已关注',
      wechatLogin: '微信登录',
      emailLogin: '邮箱登录',
      wechatLoginTips: '微信扫一扫，关注公众号后即可登录/注册'
    },
    // 热搜相关文案
    hotSearch: {
      hotSearch: '热搜',
      refresh: '刷新',
      loading: '加载中...',
      allPlatforms: '全部平台',
      baidu: '百度',
      weibo: '微博',
      toutiao: '头条',
      zhihu: '知乎',
      bilibili: 'B站',
      douyin: '抖音',
      juejin: '掘金'
    },
    // 卡片相关文案
    cards: {
      hotSearch: '热搜',
      dailyEnglish: '每日英语',
      hotSearchDescription: '聚合百度,B站,微博,知乎,头条等热搜!',
      hotSearchSubtitle: '聚合百度,B站,微博,知乎,头条,抖音,掘金等热搜!',
      dailyEnglishDescription: '每日一句英语，提升语言能力!',
      dailyEnglishSubtitle: '每日一句英语，提升语言能力!',
      refresh: '刷新',
      refreshSentence: '刷新句子'
    },
    // 分类弹窗相关文案
    categoryPopup: {
      categoryIcon: '分类图标',
      categoryName: '分类名称',
      enterCategoryName: '请输入分类名称',
      selectIcon: '请选择图标',
      enterNameAndIcon: '请输入分类名称并选择图标',
      nameLimitTip: '左侧菜单栏最多显示4个汉字',
      save: '保存'
    },
    // 起始页提示相关文案
    startPagePrompt: {
      title: '设置为浏览器首页',
      description: '将 AI灯塔桌面导航 设为首页，每次打开浏览器就能快速访问您喜爱的网站！',
      cancel: '取消',
      setAsHomepage: '设为首页',
      howToSet: '如何设置为浏览器首页',
      chromeTitle: 'Chrome浏览器设置方法：',
      chromeInstructions: ['点击右上角三个点图标', '选择"设置"', '在左侧菜单中点击"启动时"', '选择"打开特定网页或一组网页"', '点击"添加新网页"，粘贴下方网址'],
      edgeTitle: 'Edge浏览器设置方法：',
      edgeInstructions: ['点击右上角三个点图标', '选择"设置"', '点击"启动、主页和新建标签页"', '在"启动时"部分，选择"打开特定页面"', '点击"添加新页面"，粘贴下方网址'],
      firefoxTitle: 'Firefox浏览器设置方法：',
      firefoxInstructions: ['点击右上角三横线图标', '选择"选项"', '在"主页"部分，复制下方网址填入', '勾选"当Firefox启动时：显示主页"'],
      safariTitle: 'Safari浏览器设置方法：',
      safariInstructions: ['点击左上角"Safari"', '选择"偏好设置..."', '在"通用"选项卡中', '将"Safari打开时"设为"主页"', '在"主页"框中粘贴下方网址'],
      defaultTitle: '浏览器设置方法：',
      defaultInstructions: '请在浏览器设置中找到"主页"或"启动页"选项，将下方网址设为首页。',
      copyUrl: '复制网址',
      urlCopied: '网址已复制到剪贴板！',
      IHaveSet: '我已设置完成'
    },
    // 网站弹窗相关文案
    websitePopup: {
      websiteUrl: '网站地址',
      websiteName: '网站名称',
      websiteDesc: '网站简介',
      textIcon: '文字图标',
      selectIcon: '选择图标',
      iconPreview: '图标预览',
      editWebsiteNavigation: '编辑网站导航',
      saveChanges: '保存修改',
      saveAndClose: '保存并关闭',
      saveAndContinue: '保存并继续',
      fetching: '获取中...',
      enterWebsiteName: '请输入网站名称',
      enterValidUrl: '请输入有效的网站地址',
      fetchFailed: '获取网站信息失败，已使用默认图标',
      noIconUseText: '未找到网站图标，将使用文字图标',
      bgColor: '背景颜色',
      websiteNamePlaceholder: 'AI灯塔导航 - 一站式AI导航网站',
      websiteDescPlaceholder: 'AI灯塔，星海为舟，一站式AI导航网站',
      textIconPlaceholder: '最多4字',
      officialWebsite: '{domain} 官方网站'
    },
    // 在线添加组件相关文案
    onlineAddComponent: {
      quickSearch: '快捷搜索',
      selectCategory: '选择分类',
      addAll: '添加所有',
      addFailed: '添加失败',
      noSitesToAdd: '当前分类下没有可添加的网站',
      batchAdding: '正在批量添加网站...',
      batchAddSuccess: '成功添加网站到导航',
      batchAddAllFailed: '批量添加失败',
      batchAddPartial: '批量添加完成',
      websiteAdded: '已添加网站到导航',
      notConfigured: '未配置保存方法，无法添加',
      addFailedRetry: '添加失败，请重试',
      batchAddFailedRetry: '批量添加失败，请重试',
      loadFailed: '加载失败',
      noResults: '未找到相关内容',
      noData: '暂无数据'
    },
    // 扩展程序安装指导相关文案
    extensionGuide: {
      updateTitle: '扩展程序更新指导',
      installTitle: '扩展程序安装指导',
      downloadNow: '立即下载',
      installLater: '稍后安装',
      updateSteps: '更新步骤',
      installSteps: '安装步骤',
      downloadNewVersion: '下载新版本',
      downloadNewVersionDesc: '下载ZIP文件到本地',
      downloadZipToLocal: '下载ZIP文件到本地',
      extractAndReplace: '解压并替换',
      extractAndReplaceDesc: '将ZIP文件解压，用新文件替换当前扩展程序文件夹中的内容',
      extractZipAndReplace: '将ZIP文件解压，用新文件替换当前扩展程序文件夹中的内容',
      refreshExtension: '刷新扩展程序',
      refreshExtensionDesc: '在 chrome://extensions/ 页面点击扩展程序的刷新按钮',
      clickRefreshButton: '在 chrome://extensions/ 页面点击扩展程序的刷新按钮',
      verifyUpdate: '验证更新',
      verifyUpdateDesc: '刷新新标签页，确认版本已更新',
      refreshNewTab: '刷新新标签页，确认版本已更新',
      downloadAndExtract: '下载并解压',
      downloadAndExtractDesc: '下载ZIP文件并解压到本地文件夹',
      downloadZipAndExtract: '下载ZIP文件并解压到本地文件夹',
      openExtManager: '打开扩展管理',
      openExtensionManager: '打开扩展管理',
      openExtManagerDesc: 'Chrome: chrome://extensions/ | Firefox: about:addons',
      extensionUrls: 'Chrome: chrome://extensions/ | Firefox: about:addons',
      enableDevMode: '启用开发者模式',
      enableDeveloperMode: '启用开发者模式',
      enableDevModeDesc: '打开右上角"开发者模式"开关',
      turnOnDeveloperMode: '打开右上角"开发者模式"开关',
      loadExtension: '加载扩展程序',
      loadExtensionDesc: '点击"加载已解压的扩展程序"，选择解压后的文件夹',
      clickLoadUnpacked: '点击"加载已解压的扩展程序"，选择解压后的文件夹',
      version: '版本',
      currentVersion: '当前',
      updateContent: '更新内容',
      installContent: '版本说明',
      update: '更新',
      updateTip: '更新提示',
      updateTips: '更新提示',
      updateTip1: '请确保替换整个扩展程序文件夹内容',
      replaceEntireFolder: '请确保替换整个扩展程序文件夹内容',
      updateTip2: '更新后需要刷新扩展程序才能生效',
      refreshAfterUpdate: '更新后需要刷新扩展程序才能生效',
      updateTip3: '建议在更新前备份当前扩展程序文件夹',
      backupBeforeUpdate: '建议在更新前备份当前扩展程序文件夹',
      notice: '注意事项',
      notes: '注意事项',
      notice1: '请勿删除解压后的文件夹',
      doNotDeleteFolder: '请勿删除解压后的文件夹',
      notice2: '如遇安全警告，选择"仍要安装"',
      chooseInstallAnyway: '如遇安全警告，选择"仍要安装"',
      notice3: '更新时请确保浏览器已关闭所有相关标签页',
      closeTabsBeforeUpdate: '更新时请确保浏览器已关闭所有相关标签页',
      needHelp: '遇到问题？联系：',
      supportContact: '遇到问题？请联系我们获取帮助',
      features: '🏠 新标签页导航 • ⚡ 离线资源快速访问 • 🎨 个性化定制'
    },
    // 壁纸选择器相关文案
    wallpaperSelector: {
      selectWallpaper: '选择壁纸'
    },
    // Home页面相关文案
    home: {
      addWebsiteNavigation: '添加网站导航',
      batchEdit: '批量编辑',
      changeWallpaper: '更换壁纸',
      resetInitialApps: '重置初始应用',
      settings: '设置',
      deleteConfirm: '删除确认',
      resetConfirm: '重置确认',
      deleteConfirmMessage: '确定要删除这个导航吗？',
      resetConfirmMessage: '确定要还原初始应用列表吗？这将删除所有自定义添加的应用。',
      contextMenu: {
        openNavigation: '打开导航',
        editNavigation: '编辑导航',
        deleteNavigation: '删除导航',
        changeWallpaper: '更换壁纸'
      }
    },
    // 通用文案
    common: {
      add: '添加',
      addNavigation: '添加导航',
      confirm: '确认',
      cancel: '取消',
      ok: '确定',
      delete: '删除',
      edit: '编辑',
      save: '保存',
      close: '关闭',
      loading: '加载中',
      loadFailed: '加载失败，请重试',
      success: '成功',
      failed: '失败',
      error: '错误',
      retry: '重试',
      submit: '提交',
      reset: '重置',
      export: '导出',
      import: '导入',
      sync: '同步',
      logout: '退出登录',
      login: '登录',
      register: '注册',
      password: '密码',
      email: '邮箱',
      nickname: '昵称',
      confirmLogout: '确认登出',
      confirmLogoutText: '确定要退出登录吗？您的数据将保持同步。',
      confirmReset: '确认重置',
      confirmResetText: '确定要重置为默认图标吗？这将清除所有自定义设置和导航数据。',
      confirmDelete: '确认删除',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      importSuccess: '导入成功',
      importFailed: '导入失败',
      syncSuccess: '同步成功',
      syncFailed: '同步失败',
      resetSuccess: '重置成功',
      resetFailed: '重置失败',
      loginSuccess: '登录成功',
      loginFailed: '登录失败',
      logoutSuccess: '退出登录成功',
      logoutFailed: '退出登录失败',
      dataResetSuccess: '数据重置成功，页面将在1秒后刷新',
      dataImportSuccess: '数据导入成功，页面将在1秒后刷新',
      chromeBookmarksImportSuccess: 'Chrome书签导入成功！导入了',
      chromeBookmarksImportFolders: '个文件夹，',
      chromeBookmarksImportBookmarks: '个书签，页面将在1秒后刷新',
      currentVersion: '当前已是最新版本',
      extensionInfoFetchFailed: '获取扩展程序信息失败，请稍后重试',
      downloadStarted: '扩展程序下载开始',
      downloadFailed: '下载失败',
      chromeBookmarksImportFailed: '导入Chrome书签失败',
      chromeBookmarksReadFailed: '读取Chrome书签文件失败，请确保选择了正确的HTML文件',
      invalidDataFormat: '无效的数据格式',
      dataExportSuccess: '数据导出成功！',
      pleaseLogin: '请先登录以同步数据',
      dataSyncing: '正在同步数据...',
      dataImporting: '正在导入数据...',
      dataResetting: '正在重置数据...',
      chromeBookmarksImporting: '正在导入Chrome书签...',
      noUpdateAvailable: '当前已是最新版本',
      extensionInfoFetchFailedWithError: '获取扩展程序信息失败，请稍后重试',
      dragToMove: '拖拽移动'
    }
  },
  en: {
    // SettingsDrawer texts
    settings: {
      profile: 'Profile',
      openMode: 'Open Mode',
      theme: 'Theme',
      extension: 'Extension',
      about: 'About',
      // Extension related
      browserExtension: 'Browser Extension',
      setAsNewTab: 'Set as browser new tab for offline quick access',
      currentVersion: 'Current Version',
      extensionEnvironment: 'Extension Environment',
      webEnvironment: 'Web Environment',
      getLatestVersion: 'Get Latest Version',
      extensionFeatures: 'Extension Features',
      newTabNavigation: 'New Tab Navigation',
      offlineQuickAccess: 'Offline Quick Access',
      personalizedCustomization: 'Personalized Customization',
      dataSync: 'Data Sync',
      privacyProtection: 'Privacy Protection',
      supportedBrowsers: 'Supported Browsers',
      // About us related
      contactEmail: 'Contact Email',
      privacyPolicy: 'Privacy Policy',
      privacyPolicyDesc: 'Learn how we protect your privacy and data security',
      appName: 'AI Lighthouse Navigation',
      appSlogan: 'Make work smarter, make life better',
      login: 'Login',
      logout: 'Logout',
      guest: 'Guest Mode',
      loggedIn: 'Logged In',
      notLoggedIn: 'Not Logged In',
      welcomeBack: 'Welcome Back!',
      dataSynced: 'Your data is synced, enjoy the full experience',
      loginToSync: 'Login to sync your data and settings',
      dataSyncing: 'Logged in, syncing data',
      localDataOnly: 'Not logged in, using local data only',
      sync: 'Sync',
      syncing: 'Syncing',
      reset: 'Reset',
      export: 'Export Data',
      import: 'Import Data',
      importChromeBookmarks: 'Import Chrome Bookmarks',
      autoFocusSearch: 'Auto Focus Search',
      showSearch: 'Show Search',
      showQuickSearch: 'Show Quick Search',
      displayMode: 'Display Mode',
      compactDisplay: 'Compact',
      detailedDisplay: 'Detailed',
      iconSize: 'Icon Size',
      iconRadius: 'Icon Radius',
      iconSpacing: 'Icon Spacing',
      iconTextColor: 'Icon Text Color',
      dockVisible: 'Show Dock',
      sideNavAutoHide: 'Auto Hide Side Nav',
      extensionTitle: 'Browser Extension',
      extensionDesc: 'Set as browser new tab page for offline quick access',
      extensionTooltip: 'We recommend using the extension for a better experience',
      extensionVersion: 'Current Version',
      extensionEnv: 'Extension Environment',
      webEnv: 'Web Environment',
      getLatestVersion: 'Get Latest Version',
      extensionFeatures: 'Extension Features',
      newTabNav: 'New Tab Navigation',
      offlineAccess: 'Offline Quick Access',
      personalization: 'Personalization',
      dataSync: 'Data Sync',
      privacyProtection: 'Privacy Protection',
      supportedBrowsers: 'Supported Browsers',
      contactEmail: 'Contact Email',
      privacyPolicy: 'Privacy Policy',
      privacyPolicyDesc: 'Learn how we protect your privacy and data security',
      disclaimer: 'Disclaimer',
      disclaimerDesc: 'View disclaimer and user responsibilities',
      followWeChat: 'Follow WeChat Official Account',
      wechatDesc: 'Get new features, AI tips and tool sharing first',
      scanToFollow: 'Scan to follow and never miss any updates ✨',
      updateLog: 'Update Log',
      userFeedback: 'User Feedback',
      faq: 'FAQ',
      officialWebsite: 'Official Website',
      icpRecord: 'ICP Record',
      icpNumber: 'Jing ICP Bei 2024100595 Hao-4',
      version: 'AI Lighthouse Navigation',
      tagline: 'Work smarter, live better'
    },
    // SideNav texts
    sideNav: {
      login: 'Login',
      editCategory: 'Edit Category',
      delete: 'Delete',
      clickToLogin: 'Click to login',
      user: 'User',
      confirmLogout: 'Confirm Logout',
      confirmLogoutText: 'Are you sure you want to logout?',
      loginSuccess: 'Login successful! You can sync data in the settings page'
    },
    // Dock texts
    dock: {
      recentUsed: 'Recent',
      mostUsed: 'Most Used'
    },
    // TopBar texts
    topBar: {
      searchPlaceholders: {
        baidu: 'Baidu it',
        google: 'Google it',
        sogou: 'Sogou it'
      },
      searchEngines: {
        baidu: 'Baidu',
        google: 'Google',
        sogou: 'Sogou'
      },
      weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },
    // Auth texts
    auth: {
      login: 'Login',
      register: 'Register',
      resetPassword: 'Reset Password',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      verificationCode: 'Verification Code',
      getVerificationCode: 'Get Code',
      sending: 'Sending...',
      resendAfter: 's to resend',
      loginSuccess: 'Login successful',
      registerSuccess: 'Registration successful, please login',
      resetPasswordSuccess: 'Password reset successful',
      loggingIn: 'Logging in...',
      syncingData: 'Syncing data...',
      dataSyncComplete: 'Data sync complete',
      partialSyncFailed: 'Partial data sync failed, please try again later',
      loginFailed: 'Login failed, please try again later',
      enterEmail: 'Please enter your email',
      enterValidEmail: 'Please enter a valid email address',
      enterPassword: 'Please enter your password',
      enterVerificationCode: 'Please enter verification code',
      codeShouldBeSixDigits: 'Verification code should be 6 digits',
      passwordLength: 'Password length should be 6-32 characters',
      confirmPasswordRequired: 'Please confirm password',
      passwordsDoNotMatch: 'The two passwords do not match',
      userAgreement: 'User Agreement',
      privacyPolicyText: 'Privacy Policy',
      alreadyRead: 'I have read and agree to the',
      and: 'and',
      haveAccount: 'Already have an account?',
      noAccount: "Don't have an account yet?",
      loginNow: 'Login Now',
      registerNow: 'Register Now',
      forgotPassword: 'Forgot Password?',
      backToLogin: 'Back to Login',
      sendToEmail: 'Verification code sent to email',
      verifyAccount: 'Verify Account',
      verifyEmail: 'Verify Email',
      setNewPassword: 'Reset Password',
      setNewPasswordDesc: 'Set New Password',
      nextStep: 'Next',
      prevStep: 'Previous',
      verificationCodeSent: 'Verification code sent to email {email}',
      verifyCodeFailed: 'Verification failed, please check the code',
      resetPasswordFailed: 'Password reset failed, please try again later',
      codeSending: 'Send Verification Code',
      setPassword: 'Set Password (6-32 chars)',
      codeSentTo: 'Code sent to email',
      manuallyAdd: 'Manual Add',
      hotAdd: 'Hot Add',
      cardComponent: 'Card Component',
      user: 'User',
      resetPassword: 'Reset Password',
      followWeChatTitle: 'Follow WeChat Official Account',
      followWeChatDesc: 'Scan QR code to follow and get latest features and AI tips',
      followWeChatTips: 'You can continue to login/register after following',
      skipFollow: 'Skip',
      alreadyFollowed: 'Already Followed',
      wechatLogin: 'WeChat Login',
      emailLogin: 'Email Login',
      wechatLoginTips: 'Scan with WeChat, follow the official account to login/register'
    },
    // HotSearch texts
    hotSearch: {
      hotSearch: 'Hot Search',
      refresh: 'Refresh',
      loading: 'Loading...',
      allPlatforms: 'All Platforms',
      baidu: 'Baidu',
      weibo: 'Weibo',
      toutiao: 'Toutiao',
      zhihu: 'Zhihu',
      bilibili: 'Bilibili',
      douyin: 'Douyin',
      juejin: 'Juejin'
    },
    // 卡片相关文案
    cards: {
      hotSearch: 'Hot Search',
      dailyEnglish: 'Daily English',
      hotSearchZh: '热搜',
      dailyEnglishZh: '每日英语',
      hotSearchDescription: 'Aggregates trending searches from Baidu, Bilibili, Weibo, Zhihu, Toutiao, etc.!',
      hotSearchSubtitle: 'Aggregates trending searches from Baidu, Bilibili, Weibo, Zhihu, Toutiao, Douyin, Juejin, etc.!',
      dailyEnglishDescription: 'Daily English sentence to improve language skills!',
      dailyEnglishSubtitle: 'Daily English sentence to improve language skills with audio playback!',
      refresh: 'Refresh',
      refreshSentence: 'Refresh Sentence'
    },
    // Category popup texts
    categoryPopup: {
      categoryIcon: 'Category Icon',
      categoryName: 'Category Name',
      enterCategoryName: 'Please enter category name',
      selectIcon: 'Please select an icon',
      enterNameAndIcon: 'Please enter category name and select an icon',
      nameLimitTip: 'Maximum 4 Chinese characters for side menu',
      save: 'Save'
    },
    // Start page prompt texts
    startPagePrompt: {
      title: 'Set as Browser Homepage',
      description: 'Set AI Lighthouse Desktop Navigation as homepage to quickly access your favorite websites every time you open your browser!',
      cancel: 'Cancel',
      setAsHomepage: 'Set as Homepage',
      howToSet: 'How to Set as Browser Homepage',
      chromeTitle: 'Chrome Browser Setup:',
      chromeInstructions: ['Click the three dots icon in the top right', 'Select "Settings"', 'Click "On startup" in the left menu', 'Select "Open a specific page or set of pages"', 'Click "Add a new page" and paste the URL below'],
      edgeTitle: 'Edge Browser Setup:',
      edgeInstructions: ['Click the three dots icon in the top right', 'Select "Settings"', 'Click "Start, home, and new tabs"', 'Under "On startup", select "Open specific pages"', 'Click "Add a new page" and paste the URL below'],
      firefoxTitle: 'Firefox Browser Setup:',
      firefoxInstructions: ['Click the three horizontal lines icon in the top right', 'Select "Options"', 'Under "Home Page", copy and paste the URL below', 'Check "Show home page when Firefox starts"'],
      safariTitle: 'Safari Browser Setup:',
      safariInstructions: ['Click "Safari" in the top left', 'Select "Preferences..."', 'In the "General" tab', 'Set "Safari opens with" to "Homepage"', 'Paste the URL below in the "Homepage" field'],
      defaultTitle: 'Browser Setup:',
      defaultInstructions: 'Please find the "Homepage" or "Start Page" option in your browser settings and set the URL below as the homepage.',
      copyUrl: 'Copy URL',
      urlCopied: 'URL copied to clipboard!',
      IHaveSet: 'I have set it up'
    },
    // Website popup texts
    websitePopup: {
      websiteUrl: 'Website URL',
      websiteName: 'Website Name',
      websiteDesc: 'Website Description',
      textIcon: 'Text Icon',
      selectIcon: 'Select Icon',
      iconPreview: 'Icon Preview',
      editWebsiteNavigation: 'Edit Website Navigation',
      saveChanges: 'Save Changes',
      saveAndClose: 'Save and Close',
      saveAndContinue: 'Save and Continue',
      fetching: 'Fetching...',
      enterWebsiteName: 'Please enter website name',
      enterValidUrl: 'Please enter a valid website URL',
      fetchFailed: 'Failed to fetch website info, using default icon',
      noIconUseText: 'No website icon found, will use text icon',
      bgColor: 'Background Color',
      websiteNamePlaceholder: 'AI Lighthouse Navigation - AI Portal',
      websiteDescPlaceholder: 'AI Lighthouse Navigation - AI Portal',
      textIconPlaceholder: 'Max 4 characters',
      officialWebsite: '{domain} Official Website'
    },
    // Online add component texts
    onlineAddComponent: {
      quickSearch: 'Quick Search',
      selectCategory: 'Select Category',
      addAll: 'Add All',
      addFailed: 'Add failed',
      noSitesToAdd: 'No sites to add in current category',
      batchAdding: 'Batch adding websites...',
      batchAddSuccess: 'Successfully added {count} websites to navigation',
      batchAddAllFailed: 'Batch add failed, all {count} websites failed',
      batchAddPartial: 'Batch add completed: {success} successful, {failed} failed',
      websiteAdded: 'Added {name} to navigation',
      notConfigured: 'Save method not configured, cannot add',
      addFailedRetry: 'Add failed, please retry',
      batchAddFailedRetry: 'Batch add failed, please retry',
      loadFailed: 'Load Failed',
      noResults: 'No results found',
      noData: 'No data available'
    },
    // Extension guide texts
    extensionGuide: {
      updateTitle: 'Extension Update Guide',
      installTitle: 'Extension Installation Guide',
      downloadNow: 'Download Now',
      installLater: 'Install Later',
      updateSteps: 'Update Steps',
      installSteps: 'Installation Steps',
      downloadNewVersion: 'Download New Version',
      downloadNewVersionDesc: 'Download ZIP file to local',
      downloadZipToLocal: 'Download ZIP file to local',
      extractAndReplace: 'Extract and Replace',
      extractAndReplaceDesc: 'Extract ZIP file and replace contents of current extension folder with new files',
      extractZipAndReplace: 'Extract ZIP file and replace contents of current extension folder with new files',
      refreshExtension: 'Refresh Extension',
      refreshExtensionDesc: 'Click refresh button in chrome://extensions/ page',
      clickRefreshButton: 'Click refresh button in chrome://extensions/ page',
      verifyUpdate: 'Verify Update',
      verifyUpdateDesc: 'Refresh new tab to confirm version updated',
      refreshNewTab: 'Refresh new tab to confirm version updated',
      downloadAndExtract: 'Download and Extract',
      downloadAndExtractDesc: 'Download ZIP file and extract to local folder',
      downloadZipAndExtract: 'Download ZIP file and extract to local folder',
      openExtManager: 'Open Extension Manager',
      openExtensionManager: 'Open Extension Manager',
      openExtManagerDesc: 'Chrome: chrome://extensions/ | Firefox: about:addons',
      extensionUrls: 'Chrome: chrome://extensions/ | Firefox: about:addons',
      enableDevMode: 'Enable Developer Mode',
      enableDeveloperMode: 'Enable Developer Mode',
      enableDevModeDesc: 'Toggle "Developer mode" switch in top right',
      turnOnDeveloperMode: 'Toggle "Developer mode" switch in top right',
      loadExtension: 'Load Extension',
      loadExtensionDesc: 'Click "Load unpacked", select the extracted folder',
      clickLoadUnpacked: 'Click "Load unpacked", select the extracted folder',
      version: 'Version',
      currentVersion: 'Current',
      updateContent: 'Update Content',
      installContent: 'Version Notes',
      update: 'Update',
      updateTip: 'Update Tip',
      updateTips: 'Update Tips',
      updateTip1: 'Make sure to replace entire extension folder contents',
      replaceEntireFolder: 'Make sure to replace entire extension folder contents',
      updateTip2: 'Need to refresh extension for changes to take effect',
      refreshAfterUpdate: 'Need to refresh extension for changes to take effect',
      updateTip3: 'Recommended to backup current extension folder before update',
      backupBeforeUpdate: 'Recommended to backup current extension folder before update',
      notice: 'Notice',
      notes: 'Notice',
      notice1: 'Do not delete extracted folder',
      doNotDeleteFolder: 'Do not delete extracted folder',
      notice2: 'Select "Install anyway" if security warning appears',
      chooseInstallAnyway: 'Select "Install anyway" if security warning appears',
      notice3: 'Close all related tabs when updating',
      closeTabsBeforeUpdate: 'Close all related tabs when updating',
      needHelp: 'Need help? Contact: ',
      supportContact: 'Need help? Please contact us for assistance',
      features: '🏠 New Tab Navigation • ⚡ Offline Resource Access • 🎨 Customization'
    },
    // Wallpaper selector texts
    wallpaperSelector: {
      selectWallpaper: 'Select Wallpaper'
    },
    // Home page texts
    home: {
      addWebsiteNavigation: 'Add Website Navigation',
      batchEdit: 'Batch Edit',
      changeWallpaper: 'Change Wallpaper',
      resetInitialApps: 'Reset Initial Apps',
      settings: 'Settings',
      deleteConfirm: 'Delete Confirm',
      resetConfirm: 'Reset Confirm',
      deleteConfirmMessage: 'Are you sure you want to delete this navigation?',
      resetConfirmMessage: 'Are you sure you want to reset the initial app list? This will remove all custom added apps.',
      contextMenu: {
        openNavigation: 'Open Navigation',
        editNavigation: 'Edit Navigation',
        deleteNavigation: 'Delete Navigation',
        changeWallpaper: 'Change Wallpaper'
      }
    },
    // Common texts
    common: {
      add: 'Add',
      addNavigation: 'Add Navigation',
      confirm: 'Confirm',
      cancel: 'Cancel',
      ok: 'OK',
      delete: 'Delete',
      edit: 'Edit',
      save: 'Save',
      close: 'Close',
      loading: 'Loading',
      loadFailed: 'Load failed, please retry',
      success: 'Success',
      failed: 'Failed',
      error: 'Error',
      retry: 'Retry',
      submit: 'Submit',
      reset: 'Reset',
      export: 'Export',
      import: 'Import',
      sync: 'Sync',
      logout: 'Logout',
      login: 'Login',
      register: 'Register',
      password: 'Password',
      email: 'Email',
      nickname: 'Nickname',
      confirmLogout: 'Confirm Logout',
      confirmLogoutText: 'Are you sure you want to logout? Your data will remain synced.',
      confirmReset: 'Confirm Reset',
      confirmResetText: 'Are you sure you want to reset to default? This will clear all custom settings and navigation data.',
      confirmDelete: 'Confirm Delete',
      saveSuccess: 'Save successful',
      saveFailed: 'Save failed',
      exportSuccess: 'Export successful',
      exportFailed: 'Export failed',
      importSuccess: 'Import successful',
      importFailed: 'Import failed',
      syncSuccess: 'Sync successful',
      syncFailed: 'Sync failed',
      resetSuccess: 'Reset successful',
      resetFailed: 'Reset failed',
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed',
      logoutSuccess: 'Logout successful',
      logoutFailed: 'Logout failed',
      dataResetSuccess: 'Data reset successful, page will refresh in 1 second',
      dataImportSuccess: 'Data import successful, page will refresh in 1 second',
      chromeBookmarksImportSuccess: 'Chrome bookmarks import successful! Imported ',
      chromeBookmarksImportFolders: ' folders, ',
      chromeBookmarksImportBookmarks: ' bookmarks, page will refresh in 1 second',
      currentVersion: 'Already the latest version',
      extensionInfoFetchFailed: 'Failed to get extension info, please try again later',
      downloadStarted: 'Extension download started',
      downloadFailed: 'Download failed',
      chromeBookmarksImportFailed: 'Failed to import Chrome bookmarks',
      chromeBookmarksReadFailed: 'Failed to read Chrome bookmarks file, please make sure you selected the correct HTML file',
      invalidDataFormat: 'Invalid data format',
      dataExportSuccess: 'Data export successful!',
      pleaseLogin: 'Please login first to sync data',
      dataSyncing: 'Syncing data...',
      dataImporting: 'Importing data...',
      dataResetting: 'Resetting data...',
      chromeBookmarksImporting: 'Importing Chrome bookmarks...',
      noUpdateAvailable: 'Already the latest version',
      extensionInfoFetchFailedWithError: 'Failed to get extension info, please try again later',
      dragToMove: 'Drag to Move'
    }
  }
};

/**
 * 获取当前语言
 */
export const getCurrentLanguage = () => {
  return localStorage.getItem('language') || LANGUAGES.ZH;
};

/**
 * 设置语言
 */
export const setLanguage = (language) => {
  localStorage.setItem('language', language);
  window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language } }));
};

/**
 * 获取翻译文本
 */
export const t = (key, ...args) => {
  const language = getCurrentLanguage();
  const keys = key.split('.');
  let text = languageTexts[language];
  
  for (const k of keys) {
    if (text && typeof text === 'object') {
      text = text[k];
    } else {
      // 如果找不到翻译，返回默认值或key本身
      return args.length > 0 ? args[0] : key;
    }
  }
  
  return text || key;
};

export default { LANGUAGES, languageTexts, getCurrentLanguage, setLanguage, t };

